/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespTopModule_item = {
    readonly title: string | null;
    readonly photos: ReadonlyArray<{
        readonly smallPath: string | null;
    } | null> | null;
    readonly seller: {
        readonly isAccessible: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSellerButton_item">;
    readonly " $refType": "PdpRespTopModule_item";
};
export type PdpRespTopModule_item$data = PdpRespTopModule_item;
export type PdpRespTopModule_item$key = {
    readonly " $data"?: PdpRespTopModule_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespTopModule_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTopModule_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '95c948f5ad4a60ad852573c24af969b3';
export default node;
